import { IconProps } from "./types";

export const CheckSomeIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_564_90417)">
        <path
          d="M14 16H2C0.9 16 0 15.1 0 14V2C0 0.9 0.9 0 2 0H14C15.1 0 16 0.9 16 2V14C16 15.1 15.1 16 14 16ZM12.5 8C12.5 7.45 12.05 7 11.5 7H4.51C3.96 7 3.51 7.45 3.51 8C3.51 8.55 3.96 9 4.51 9H11.5C12.05 9 12.5 8.55 12.5 8Z"
          fill={fillColor ?? "#E6E6E6"}
        />
      </g>
      <defs>
        <clipPath id="clip0_564_90417">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
